// eslint-disable-next-line import/no-cycle
import AuthService from "../../AuthService";

const support = {
  // venue-hire
  getVenueHire(page) {
    return AuthService.get(`/customer-support/venue-hire?page=${page}`);
  },
  showVenueHire(id) {
    return AuthService.get(`/customer-support/venue-hire/${id}`);
  },
  createVenueHire(data) {
    return AuthService.post("/customer-support/venue-hire", data);
  },
  updateVenueHire(id, data) {
    return AuthService.put(`/customer-support/venue-hire/${id}`, data);
  },
  deleteVenueHire(id) {
    return AuthService.delete(`/customer-support/venue-hire/${id}`);
  },
  // contact
  getContact(page) {
    return AuthService.get(`/customer-support/contact-branch?page=${page}`);
  },
  showContact(id) {
    return AuthService.get(`/customer-support/contact-branch/${id}`);
  },
  createContact(data) {
    return AuthService.post("/customer-support/contact-branch", data);
  },
  updateContact(id, data) {
    return AuthService.put(`/customer-support/contact-branch/${id}`, data);
  },
  deleteContact(id) {
    return AuthService.delete(`/customer-support/contact-branch/${id}`);
  },
  // group-visit
  getGroupVisit(page) {
    return AuthService.get(`/customer-support/group-visit?page=${page}`);
  },
  showGroupVisit(id) {
    return AuthService.get(`/customer-support/group-visit/${id}`);
  },
  createGroupVisit(data) {
    return AuthService.post("/customer-support/group-visit", data);
  },
  updateGroupVisit(id, data) {
    return AuthService.put(`/customer-support/group-visit/${id}`, data);
  },
  deleteGroupVisit(id) {
    return AuthService.delete(`/customer-support/group-visit/${id}`);
  }
};
export default support;
